import React from 'react';
import ReactDOM from 'react-dom';
import { node } from 'prop-types';
import { useLockBodyScroll } from '@fiverr-private/hooks';
import useForceUpdate from './hooks/useForceUpdate';

const Portal = ({ children }) => {
    const portalNode = React.useRef(null);
    const forceUpdate = useForceUpdate();

    useLockBodyScroll();

    React.useLayoutEffect(() => {
        portalNode.current = document.createElement('div');

        document.body.appendChild(portalNode.current);

        forceUpdate();

        return () => {
            if (portalNode.current) {
                document.body.removeChild(portalNode.current);
            }
        };
    }, [forceUpdate]);

    return portalNode.current ? ReactDOM.createPortal(children, portalNode.current) : null;
};

Portal.propTypes = {
    children: node
};

export default Portal;
